import React, { useState, useEffect, useCallback } from 'react';

import UserList from './ctn/admin/UserList.js';
import UserGraph from './ctn/admin/UserGraph.js';
//import Filter from './ctn/eBay/Filter.js'
//import ItemsTable from './ctn/eBay/ItemsTable.js'
//import Pagination from './ctn/eBay/Pagination.js'
//import Modal from './ctn/eBay/Modal.js'
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
//import { faCaretRight } from '@fortawesome/free-solid-svg-icons'
import DB from '../db.js'
import {ajaxPerso} from "../fnc.js"

const Admin = (props) => {
	
	const [users, setUsers] = useState([]);
	const [permissions, setPermissions] = useState([]);
	const defaultLevel = "user";

	const loadUsers = useCallback(() => {
		DB.load("users/", {}, (data, nbr) => {
			let tab = [],
				dv = data.val() || {}

			// console.info('Users list', dv);
			
			for (const key in dv)
				if (dv.hasOwnProperty(key)){
					const obj = dv[key];
					obj.uid = key; // Important to base on the real Firebase key, the other one save in the object can be wrong
					obj.level = ("level" in obj? obj.level : defaultLevel)
					tab.push(obj)
				}

			console.info("tab_test", tab);
			setUsers(tab);
		});
	}, []);

	const loadPermission = useCallback(() => {
		DB.load("permissions/", {}, (data, nbr) => {
			let listOut = [],
				dv = data.val() || {}

			for (const key in dv)
				if (dv.hasOwnProperty(key)){
					const obj = dv[key];
					listOut.push(obj);
				}

			setPermissions(listOut);
		});
	}, []);

	useEffect(() => {
		if(!props.securityClearance(props)) return;
		
		loadUsers();
		loadPermission();
		//this.updateItem();
	}, [loadUsers, loadPermission, props]);

	/* changeLevel(uid, newPermUid){
		console.info(newPermUid);

		if(level == newLevel){
			console.warn("Same level choosen");
			return false;
		}
		
		DB.load("permissions/"+uid, {
			'once': true
		}, (data) => {
			let dv = data.val()
			dv.level  = newLevel;
			dv.uid  = uid; // We base on the real key generated by firebase
			DB.add(dv, "users/", (e, key) => {
				if(!e)
					props.info({"success": "User privilege updated."})
			})
		});
	} */

	const changeLevel_v2 = useCallback((uid, newPermUid) => {
		if(!newPermUid) newPermUid = [];

		ajaxPerso({
			"api": "account",
			"trigger": "changeUserPermission",
			"uidUser": uid,
			"listUidPermissions": newPermUid.map(o => {
				return o.value
			}).join(',')
		}, function( r ) {
			console.info('Triggered: changeUserPermission', r);
			if(r.error)
				console.warn(r.error);
			else if(r.success)
				props.info({success: "Updated"})
		})
	}, [props]);

	const changeNeedsToPunchInOut = useCallback((uid, newNeedsToPunchInOut) => {
		ajaxPerso({
			"api": "account",
			"trigger": "changeUserNeedsToPunchInOut",
			"uid": uid,
			"needs_punch_in_out": newNeedsToPunchInOut
		}, (r) => {
			console.info('Triggered:_changeUserNeedsToPunchInOut', r);
			if(r.error)
				console.warn(r.error);
			else if(r.success){
				props.info({success: "Updated"})
				if(props.updateUserPunchRequirement)
					props.updateUserPunchRequirement(uid, newNeedsToPunchInOut)
				// Load users again
				loadUsers()
			}
		})
	}, [props, loadUsers]);

	const changeUserActive = useCallback((uid, isActive) => {
		ajaxPerso({
			"api": "account",
			"trigger": "changeUserActive",
			"uid": uid,
			"is_active": isActive
		}, (r) => {
			if(r.error)
				props.info({error: r.error});
			else if(r.success){
				props.info({success: "Account status updated"});
				if(props.updateAccountActive)
					props.updateAccountActive(uid, isActive);
			}
		});
	}, [props]);

	const getLevel = useCallback((uid) => {
		if(!uid)
			return;

		let level = ''

		users.forEach((obj) => {
			if(obj.uid === uid)
				level = ("level" in obj? obj.level : defaultLevel)
		})

		return level
	}, [users]);

	const getUsers = useCallback((uid) => {
		if(typeof uid !== "undefined"){
			for (let index = 0; index < users.length; index++) {
				if( users[index].uid == uid )
					return users[index];
			}
		}else
			return users;
	}, [users]);

	/*triggerChangeLevel(uid){

		if(!uid)
			return;

		let users = users

		users.forEach((obj) => {
			if(obj.uid === uid)
				users
		})
	}*/

	if(!props.securityClearance(props))	return "";
	
	return (
		props.parent.match.params.idUser && users.length > 0?
			<UserGraph 
				{...props}
				getUsers={getUsers}
				getLevel={getLevel}
				getLevels={props.getLevels}
				match={props.parent.match}
				loading={props.loading}
				userData={getUsers(props.parent.match.params.idUser)}
				permissions={permissions}
				changeUserActive={changeUserActive}
			/>
			:
			<UserList 
				{...props}
				getUsers={getUsers} 
				getLevel={getLevel} 
				getLevels={props.getLevels} 
				match={props.parent.match}
				loading={props.loading}
				changeLevel={changeLevel_v2}
				changeNeedsToPunchInOut={changeNeedsToPunchInOut}
				changeUserActive={changeUserActive}
				permissions={permissions}
			/>
	);
}

export default Admin;
